import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { compose } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import { PrimaryButton, ButtonSizeOptions, ButtonText, ButtonIcon } from "@loanbossinc/component-library";

import { formatRateThreeDecimal } from "../../Global/Metric/formattersv2";

import { generateCashflows, getConfigItems, downloadCashflows } from "./cashflowTestHarness.store";
import CriteriaDrawer from "./CriteriaDrawer";
import LegTable from "./LegTable";
import SelectFilter from "./SelectFilter";
import DateFilter from "./DateFilter";
import { TableWrapper, StyledButtonText, ButtonWrapper, TopButtonWrapper, StyledSubText, CellContentWrapper, PageTitle } from "./testHarness.style";

const DataTableWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-left: 15px;
    margin-top: 20px;
`;
const PillWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-left: 15px;
    margin-top: 20px;
`;
const StyledPill = styled.div`
    width: 100px;
    left: 100px;
    background: ${props => (props.isActive ? "#5F6368" : "#FFFFFF")};
    border: 1px solid #5F6368;
    box-sizing: border-box;
    border-radius: ${props => (props.isLeftPill ? "16px 0px 0px 16px" : "0px 16px 16px 0px")};

    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    display: flex;
    align-items: center;
    color: ${props => (props.isActive ? "#FFFFFF" : "#5F6368")};
    justify-content: center;
    height: 36px;
`;

const CashflowTestHarness = props => {
  const { getConfigItems, downloadCashflows } = props;

  useEffect(() => {
    getConfigItems();
  }, []);

  const [resultsFormatting, setResultsFormatting] = useState("pretty");
  const [showFilter, setShowFilter] = useState(false);
  const [showCriteriaDrawer, setShowCriteriaDrawer] = useState(false);
  const columns = legNumber => [
    {
      Header: `Leg ${legNumber}`,
      columns: [
        {
          accessor: "periodStart",
          sortType: "basic",
          Header: "Calculation Start",
          Filter: DateFilter,
          filter: "dateBetween",
          Cell: item => (
            <CellContentWrapper>
              {item.value && moment(item.value).format("MM/DD/YYYY")}
            </CellContentWrapper>
          )
        },
        {
          accessor: "periodEnd",
          sortType: "basic",
          Header: "Calculation End",
          Filter: DateFilter,
          filter: "dateBetween",
          Cell: item => (
            <CellContentWrapper>
              {item.value && moment(item.value).format("MM/DD/YYYY")}
            </CellContentWrapper>
          )
        },
        {
          accessor: "paymentDate",
          sortType: "basic",
          Header: "Payment Date",
          Filter: DateFilter,
          filter: "dateBetween",
          Cell: item => (
            <CellContentWrapper>
              {item.value && moment(item.value).format("MM/DD/YYYY")}
            </CellContentWrapper>
          )
        },
        {
          accessor: "fixingDate",
          sortType: "basic",
          Header: "Reset Date",
          Filter: DateFilter,
          filter: "dateBetween",
          Cell: item => (
            <CellContentWrapper>
              {item.value && moment(item.value).format("MM/DD/YYYY")}
            </CellContentWrapper>
          )
        },

        {
          accessor: "rate",
          sortType: "basic",
          Header: "Rate",
          Filter: SelectFilter,
          Cell: item => (
            <CellContentWrapper>
              {formatRateThreeDecimal(item.value)}
            </CellContentWrapper>
          )
        },
        {
          accessor: "resetRate",
          sortType: "basic",
          Header: "Reset Rate",
          Filter: SelectFilter,
          Cell: item => (
            <CellContentWrapper>
              {formatRateThreeDecimal(item.value)}
            </CellContentWrapper>
          )
        }
      ]
    }
  ];

  const splitCashflows = legNumber => props.cashflows.filter(cashflow => cashflow.legIndex === legNumber);

  return (
    <div>
      <CriteriaDrawer isOpen={showCriteriaDrawer} closeDrawer={() => setShowCriteriaDrawer(!showCriteriaDrawer)} />
      <div>
        <PageTitle>Cashflows</PageTitle>
        <TopButtonWrapper style={{ flexBasis: "50%", flex: "0 1 auto" }}>

          <PrimaryButton
            style={{ marginLeft: 24 }}
            label={`${showCriteriaDrawer ? "Close" : "Open"} Search Criteria`}
            onClick={() => setShowCriteriaDrawer(!showCriteriaDrawer)}
            size={ButtonSizeOptions.smFluid}
          />
          <PrimaryButton
            style={{ marginLeft: 24 }}
            label={"Download"}
            onClick={() => downloadCashflows({ cashflowData: props.cashflows })}
            disabled={!props.cashflows.length}
            size={ButtonSizeOptions.smFluid}
          />
          {/* <PillWrapper>
                        <StyledPill isActive={resultsFormatting === "raw"} isLeftPill={true} onClick={() => setResultsFormatting("raw")}>
                            Raw
                        </StyledPill>
                        <StyledPill isActive={resultsFormatting === "pretty"} isLeftPill={false} onClick={() => setResultsFormatting("pretty")}>
                            Pretty
                        </StyledPill>
                    </PillWrapper> */}

        </TopButtonWrapper>
        {props.cashflows.length > 0 &&
          <DataTableWrapper>
            {/* <StyledButtonText onClick={() => { setShowFilter(!showFilter) }} iconName='filter_list' label={!showFilter ? 'Filter Table' : 'Clear Filter'} reverse={true} /> */}
            <TableWrapper>
              <LegTable columns={columns(1)} data={splitCashflows(0)} showFilter={showFilter} />
            </TableWrapper>
            {props.numberOfLegs > 1 &&
              <TableWrapper>
                <LegTable columns={columns(2)} data={splitCashflows(1)} showFilter={showFilter} />
              </TableWrapper>}
          </DataTableWrapper>}
      </div>
    </div>
  );
};

const mapStateToProps = ({ authentication, cashflowTestHarness }) => ({
  authentication,
  ...cashflowTestHarness
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    generateCashflows,
    getConfigItems,
    downloadCashflows
  })
)(CashflowTestHarness);
